import * as angular from "angular";
import { utc } from "moment-timezone";

function acceptedFormats(displayFormat: string): string[] {
	const dates = ["M/D/YYYY", "M/D/YY", "M-D-YYYY", "M-D-YY", "M.D.YYYY", "M.D.YY"];
	const times = displayFormat.includes("A") ? ["h:mm A", "h:mmA"] : ["H:mm"];
	const dateTimes = /[Hh]/.test(displayFormat)
		? dates.flatMap(date => times.map(time => `${date} ${time}`))
		: [];

	return [displayFormat, "YYYY-MM-DDTHH:mm", "YYYY-MM-DD", ...dateTimes, ...dates];
}

/** Parse wall components independently of the device's daylight-saving transitions. */
export default angular.module("vesl.extensions.json-schema.wall-date-input", [])
	.directive("jsonSchemaWallDateInput", () => ({
		restrict: "A",
		require: "ngModel",
		link: (scope: angular.IScope, _element: angular.IAugmentedJQuery, attributes: angular.IAttributes, model: angular.INgModelController) => {
			const format = () => scope.$eval(attributes.jsonSchemaWallDateInput) as string;

			model.$formatters.push((value: unknown) => value instanceof Date ? utc(value).format(format()) : typeof value === "string" ? value : "");
			model.$parsers.push((value: string) => {
				if(!value) {
					model.$setValidity("date", true);
					return null;
				}

				const parsed = utc(value, acceptedFormats(format()), true);
				model.$setValidity("date", parsed.isValid());

				return parsed.isValid() ? parsed.toDate() : value;
			});
		}
	}))
	.name;
